stockpurchaseBackAction<!-- 采购退货数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="100px" id="mainInfo" class="baseForm" ref="sendDataInfo" :model="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" :key="formOneKey" v-if="formOneValue.isShow == 1"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item"
                                                                :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                                  @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField,formOneValue.focusField)"
                                                                  :disabled="formOneValue.isChange == 0 ||sendDataInfo.rgapplydetailInfos.length>0">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField,formOneValue.focusField)"
                                                                       slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0 ||sendDataInfo.rgapplydetailInfos.length>0">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- 退货申请日期 -->
                                                    <df-date class="form_codition" v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneValue.isIndex,formOneValue.focusField)"
                                                             v-model="sendDataInfo[formOneValue.entityField]" :isdisabled="formOneValue.isChange == 0||sendDataInfo.rgapplydetailInfos.length>0"
                                                             :isShowLong="false"></df-date>
                                                    <el-select class="form_codition" clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'"
                                                               @visible-change="(e)=>{selectChange(e,formOneValue.isIndex,formOneValue.focusField)}"
                                                               :disabled="formOneValue.isChange == 0||sendDataInfo.rgapplydetailInfos.length>0" @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]"
                                                               placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value"></el-option>
                                                    </el-select>
                                                    <!-- 退货原因 -->
                                                    <el-input class="form_codition" clearable v-else :disabled="formOneValue.isChange == 0||sendDataInfo.rgapplydetailInfos.length>0"
                                                              @keyup.enter.native="nextFocus(formOneValue.isIndex,formOneValue.focusField)" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" :key="formOneKey" v-if="formOneValue.isShow == 1"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                    <span v-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{ sendDataInfo[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo[formOneValue.entityField]">
                                                            {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                        {{getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField,formOneValue.fieldType, formOneValue.formatterContent) }}
                                                    </span>
                                                    <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{ sendDataInfo[formOneValue.entityField]== 1 ? "是" : "否"}}</span>
                                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                    <el-form :inline="true" size="mini" @submit.native.prevent>
                                        <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                            <el-button type="primary" size="mini" @click="addDetails('sendDataInfo')">增加明细</el-button>
                                            <el-button type="primary" size="mini" @click="deleteDetails()">删除</el-button>
                                            <el-button @click="exportTemplate" size="mini" type="primary">下载模版</el-button>
                                            <el-button @click="importDetails" size="mini" type="primary">导入明细</el-button>
                                        </div>
                                        <el-table size="mini" ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange"
                                                  :data="sendDataInfo.rgapplydetailInfos" border style="width: 100%" :height="mxHeight">
                                            <el-table-column label="选择操作" width="90" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
                                            <template v-for="(formOneValue, formOneKey) in mxForm" >
                                                <el-table-column :key="formOneKey" align="center" :prop="formOneValue.entityField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" :label="formOneValue.showField"
                                                                 v-if="formOneValue.isShow == 1">
                                                    <template slot-scope="scope">
                                                        <span v-if="formOneValue.fieldType == 'date'">
                                                            <span v-if="scope.row[formOneValue.entityField]">
                                                                {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                            </span>
                                                        </span>
                                                        <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo.rgapplydetailInfos[scope.$index][formOneValue.entityField]"
                                                                  :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                                  @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField,formOneValue.focusField,true)"
                                                                  :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField,formOneValue.focusField,true)" slot="append"
                                                                       icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            </el-button>
                                                        </el-input>
                                                        <span v-else-if="formOneValue.isRift == 1">
                                                            <a @click="toDetail(scope.row[formOneValue.riftField])">{{ scope.row[formOneValue.entityField] }}</a>
                                                        </span>
                                                        <input v-else-if="formOneValue.entityField == 'rgdRetnumber' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                               @keyup.enter="tableNextFocus(formOneValue.focusField, scope.$index)" clearable class="newInput" @input="calculation()" type="number" :min="0"
                                                               v-model="sendDataInfo.rgapplydetailInfos[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength" />
                                                        <span v-else-if="formOneValue.entityField == 'bgmId'">{{ sendDataInfo.rgapplydetailInfos[scope.$index].bgmName }}</span>
                                                        <span v-else-if="formOneValue.fieldType == 'formatter'">{{getValue(scope.row[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)}}</span>
                                                        <span v-else>
                                                            {{ sendDataInfo.rgapplydetailInfos[scope.$index][formOneValue.entityField] }}
                                                        </span>
                                                    </template>
                                                </el-table-column>
                                            </template>

                                        </el-table>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme :oneFlag="true" ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog title="导入" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
            <initDataUpload :parentSearchData="upLoadSearchData" :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
            </initDataUpload>
        </el-dialog>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="100">
                    <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.validity) }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "stockpurchaseReturnAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            selectedDetailsIndex: 0,
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            isLoaded: false,
            mxHeight: 0,
            dictionariesDatas: [], //退货原因
            mxForm: [],
            tabForm: [],
            footForm: [],
            sField: '', // 赋值字段
            fField: '', //焦点字段
            inputel: '', //所有input对象
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            seType: "",
            seIndex: 0,
            seWidth: '',
            parentSearchData: {},
            selectedRow: [], // 当前已选择行
            stNameFlag: false,
            detaislDataInfo: {},
            importShow: false,
            importType: "",
            url: "",
            upLoadSearchData: {},
            //--------------------
            showDialog: false,
            dialogList: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.rgapplydetailInfos": {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.totalCount = 0; //总条目数
                this.sendDataInfo.totalMoney = 0; // 总金额
                this.sendDataInfo.totalNumber = 0; // 总数量
                newValue.forEach((item, keys) => {
                    let updatedItem = this.$common.updataNum('rgdRetnumber', item);
                    let rgdRetnumber = parseFloat(updatedItem.rgdRetnumber) || 0;
                    if (rgdRetnumber <= 0) {
                        this.sendDataInfo.rgapplydetailInfos[keys].money = 0;
                        this.sendDataInfo.rgapplydetailInfos[keys].psmoney = 0;
                        return false;
                    }
                    if (rgdRetnumber > item.rgdOldnumber) {
                        return this.$message({
                            message: "退货数量不能大于原单数量",
                            type: "error",
                        });
                    }

                    // 计算金额 单价*数量
                    this.sendDataInfo.rgapplydetailInfos[keys].money =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(item.price, rgdRetnumber)
                        );

                    // 计算含税金额 含税价格*数量
                    this.sendDataInfo.rgapplydetailInfos[keys].psmoney =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(item.psprice, rgdRetnumber)
                        );

                    this.sendDataInfo.totalMoney = NP.plus(
                        this.sendDataInfo.totalMoney,
                        this.sendDataInfo.rgapplydetailInfos[keys].psmoney
                    );

                    this.sendDataInfo.totalNumber = NP.plus(
                        this.sendDataInfo.totalNumber,
                        item.rgdRetnumber
                    );
                });
                this.sendDataInfo.totalCount = newValue.length;
            },
            deep: true,
        },
        "sendDataInfo.dismode": {
            handler: function (newstr, oldValue) {
                this.$nextTick(() => {
                    let newValue = newstr.replace(/\s*/g, "");
                    this.sendDataInfo.dismode = newValue
                    if (newValue != "物流" || newValue == '') {
                        this.sendDataInfo.companyName = ''
                        this.sendDataInfo.loId = ''
                        this.tabForm[0].jurconfigform.forEach((item) => {
                            if (item.entityField == "companyName") {
                                item.isShow = 0;
                            }
                        })
                    } else {
                        this.tabForm[0].jurconfigform.forEach((item) => {
                            if (item.entityField == "companyName") {
                                item.isShow = 1;
                            }
                        });
                    }

                })
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        //----------------------导入
        // 触发组件的提交
        fileSuccess(val) {
        },
        // 关闭弹窗
        closeExcel(val) {
            this.importShow = false
            if (val.list.length > 0) {
                const list = val.list.map(item => {
                    const obj = {};
                    for (const key in this.detaislDataInfo) {
                        // 只赋值 detaislDataInfo 有效字段
                        if (this.detaislDataInfo[key] !== undefined && this.detaislDataInfo[key] !== null) {
                            this.$set(obj, key, item[key]);
                        }
                    }
                    return obj;
                });
                this.sendDataInfo.rgapplydetailInfos.push(...list);
            }
        },
        exportTemplate() {
            window.location.href = `${window.global_config.BASE_URL}/RgApply/importTemplate`
        },
        importDetails() {
            this.$refs['sendDataInfo'].validate((valid) => {
                if (valid) {
                    this.importType = 'exportReturnDetail'
                    this.url = 'RgApply/exportReturnDetail'
                    this.importShow = true
                    this.upLoadSearchData.opmId = this.sendDataInfo.opmId;
                    this.upLoadSearchData.smId = this.sendDataInfo.smId;
                    this.upLoadSearchData.coId = this.sendDataInfo.coId;
                    this.upLoadSearchData.salesId = this.sendDataInfo.salesId;
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        ///---------------------
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (fieldType == 'formatter') {
            console.log(val, type, fieldType, arr,'11111111111')
                
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        addDetails(sendDataInfo) {
            var flag = false;
            if (this.sendDataInfo.rgapplydetailInfos.length > 0) {
                this.sendDataInfo.rgapplydetailInfos.forEach((item) => {
                    if (item.bgmId == "") {
                        flag = true;
                        return this.$message({
                            message: "请不要重复新增空白行",
                            type: "warning",
                        });
                    }
                });
            }
            if (flag) {
                return;
            }
            if (!this.$refs[sendDataInfo]) {
                return
            }
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sendDataInfo.rgapplydetailInfos.push({});
                    var index = this.sendDataInfo.rgapplydetailInfos.length - 1;
                    for (const key in this.detaislDataInfo) {
                        this.$set(
                            this.sendDataInfo.rgapplydetailInfos[index],
                            key,
                            this.detaislDataInfo[key]
                        );
                    }
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.rgapplydetailInfos.length - 1
                        );
                        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.rgapplydetailInfos[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            }
        },
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) {
                this.$parent.$parent.toDetail(orderId);
            } else {
                this.$parent.$parent.$parent.toDetail(orderId);
            }
        },
        calculation() {
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.rgapplydetailInfos.forEach((item) => {
                let psprice = item.psprice ? parseFloat(item.psprice) : 0
                let rgdRetnumber = item.rgdRetnumber ? parseFloat(item.rgdRetnumber) : 0
                let ppargdRetnumberdNum = item.ppargdRetnumberdNum ? parseFloat(item.ppargdRetnumberdNum) : 0
                // 含税金额
                item.psmoney = this.$common.getDecimalInfo(
                    3,
                    NP.times(psprice, rgdRetnumber)
                );
                // 金额
                item.money = this.$common.getDecimalInfo(
                    3,
                    NP.times(item.price, ppargdRetnumberdNum)
                );
                this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                    3,
                    NP.plus(this.sendDataInfo.totalMoney, item.psmoney)
                );
                this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
                    1,
                    NP.plus(this.sendDataInfo.totalNumber, rgdRetnumber)
                );
            });
            this.sendDataInfo.totalCount =
                this.sendDataInfo.rgapplydetailInfos.length;
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e, index, focusField) {
            if (e == false) {
                this.nextFocus(index, focusField);
            }
        },
        onInput() {
            this.$forceUpdate();
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField, fField, flag) {
            setTimeout(() => {
                this.showDialog = false
            }, 16.7);
            this.parentSearchData = {};
            this.seIndex = index;
            // 动态赋值主表和明细相关字段
            switch (type) {
                case "stName":
                    this.stNameFlag = !!flag;
                    if (flag) {
                        this.stNameFlag = flag;
                        const detail = this.sendDataInfo.rgapplydetailInfos[this.seIndex] || {};
                        this.parentSearchData.lotno = detail.lotno;
                        this.parentSearchData.stName = detail.stName;
                    } else {
                        this.stNameFlag = false;
                        this.parentSearchData.stName = this.sendDataInfo.stName;
                    }
                    break;
                case "saiAddress":
                    this.parentSearchData.smId = this.sendDataInfo.smId;
                    break;
                case "bgmName":
                    this.parentSearchData.opmId = this.sendDataInfo.opmId;
                    this.parentSearchData.smId = this.sendDataInfo.smId;
                    this.parentSearchData.coId = this.sendDataInfo.coId;
                    this.parentSearchData.salesId = this.sendDataInfo.salesId;
                    this.parentSearchData.stId = this.sendDataInfo.stId;
                    this.parentSearchData.isRga = 1
                    break;
                default:
                    break;
            }

            // 通用：补充当前字段值
            this.parentSearchData[type] = this.sendDataInfo[type];

            removeEventListener('keyup', this.keyUp);
            this.DialogVisible = true;
            this.seId = sId;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        changeInputModel(val) {
            // console.log('fanhui', val);
            if (val && typeof val === 'object' && Object.keys(val).length > 0) {
                addEventListener('keyup', this.keyUp)//创建监听键盘事件
                if (this.seType == "stName") {
                    let arr = this.sField.split(',')
                    arr.forEach(item => {
                        if (this.stNameFlag) {
                            this.$set(this.sendDataInfo.rgapplydetailInfos[this.selectedDetailsIndex], item, val[item]);
                        } else {
                            this.$set(this.sendDataInfo, item, val[item]);
                        }
                    })
                } else if (this.seType == "slCode") {
                    this.paramValue1(val)
                } else if (this.seType == 'bgmName') {
                    if (Array.isArray(val)) {
                        // 清理空数据
                        this.sendDataInfo.rgapplydetailInfos = this.sendDataInfo.rgapplydetailInfos.filter(item =>
                            item.bgmId !== "" && item.bgmName !== "");

                        // 创建新项目数组
                        const newItems = val.map(item => {
                            const newItem = { ...item };
                            newItem.rgdOldnumber = item.psbkdIsnumber;
                            return newItem;
                        });

                        // 批量创建完整项目对象（允许重复商品直接追加）
                        const completeNewItems = newItems.map(item => {
                            const completeItem = {};
                            Object.keys(this.detaislDataInfo).forEach(key => {
                                this.$set(completeItem, key, item[key] !== undefined ? item[key] : this.detaislDataInfo[key]);
                            });
                            return completeItem;
                        });

                        // 一次性添加所有新项目
                        this.sendDataInfo.rgapplydetailInfos.push(...completeNewItems);

                        // 更新选中索引
                        if (completeNewItems.length > 0) {
                            this.selectedDetailsIndex = this.sendDataInfo.rgapplydetailInfos.length - 1;
                        }
                    } else if (typeof val === 'object' && val !== null) {
                        const detail = this.sendDataInfo.rgapplydetailInfos[this.selectedDetailsIndex];
                        for (const key in val) {
                            if (key in detail) {
                                this.$set(detail, key, val[key]);
                            }
                        }
                        this.$set(detail, 'rgdOldnumber', val.psbkdIsnumber);
                    }


                } else if (this.seType == 'smName') {
                    this.$http
                        .checkVendorLicense({
                            //校验购进单位
                            formId: this.formDataList[0].jciId, //表单ID
                            unitId: val.smId, //单位ID
                        })
                        .then((res) => {
                            this.dialogList = []
                            if (res && res.status == 200) {
                                let flag = -1
                                if (res.result != null && res.result.length > 0) {
                                    res.result.forEach(item => {
                                        this.dialogList.push(item)
                                    })
                                    flag = this.dialogList.findIndex(item => item.level == 0)
                                    this.showDialog = true
                                }
                                if (flag == -1) {
                                    this.parentSearchData.smId = val.smId;
                                    this.sendDataInfo.smName = val.smName;
                                    this.sendDataInfo.smId = val.smId;
                                    this.$http.queryDefaultSales({
                                        ids: [val.smId]
                                    }).then((res) => {
                                        if (res && res.status == 200) {
                                            var valObj = {
                                                ...val,
                                                ...res.result,
                                            }
                                            if (valObj.salesId && valObj.salesName && this.sField.indexOf('salesId') != -1 && this.sField.indexOf('salesName') != -1) {
                                                this.$http.checkSalesLicense({
                                                    //校验供应商业务员
                                                    formId: this.formDataList[0].jciId, //表单ID
                                                    salesId: valObj.salesId, //业务员ID
                                                }).then((res) => {
                                                    if (res && res.status == 200) {
                                                        let flag = -1;
                                                        if (res.result != null && res.result.length > 0) {
                                                            res.result.forEach(item => {
                                                                this.dialogList.push(item)
                                                            })
                                                            flag = this.dialogList.findIndex(
                                                                (item) => item.level == 0
                                                            );
                                                            this.showDialog = true;
                                                        }
                                                        if (flag == -1) {
                                                            this.paramValue(valObj);
                                                        }
                                                    } else {
                                                        this.lineMessageBox(res);

                                                        return false;
                                                    }
                                                }).catch((rej) => {
                                                    this.lineMessageBox(rej);
                                                });
                                            } else {
                                                this.paramValue(val);
                                            }
                                        } else {
                                            this.paramValue(val);
                                        }
                                    }).catch((rej) => {
                                        this.lineMessageBox(rej);
                                    });
                                } else {
                                    this.showDialog = true
                                }
                            } else {
                                this.lineMessageBox(res);
                                this.parentSearchData.smId = "";
                                this.clearValue();
                            }
                        })
                        .catch((rej) => {
                            this.lineMessageBox(rej);
                            this.parentSearchData.smId = "";
                            this.clearValue();
                        });
                } else {
                    this.paramValue(val)
                }
            }
            this.DialogVisible = false;
        },
        // 赋值字段
        paramValue(val) {
            console.log(this.sField);
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField)
            })
        },
        // 赋值字段
        paramValue1(val) {
            console.log(this.sField);
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo.rgapplydetailInfos[this.seIndex][item] = val[item]
            })
            if (this.fField) {
                this.tableNextFocus(this.fField, this.seIndex)
            }
        },
        // 输入框切换焦点
        nextFocus(index, focusField) {
            if (focusField == 'keydown') {
                this.addDetails()
                return
            }
            if (index >= (this.inputel.length - 1)) {
                if (this.sendDataInfo.rgapplydetailInfos.length > 0) {
                    this.tableNextFocus('bgmName', this.selectedDetailsIndex)
                } else {
                    this.addDetails()
                }
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            if (field == '') return
            if (field == 'keydown') {
                if (index == this.sendDataInfo.rgapplydetailInfos.length - 1) return
                if (this.sendDataInfo.rgapplydetailInfos[index + 1] != undefined) {
                    this.$refs['bgmName'][index + 1].focus() //跳退货数量
                    this.selectedDetailsIndex = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.rgapplydetailInfos[this.selectedDetailsIndex]);
                    })
                    return
                }
            }
            this.$refs[field][index].focus()
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == 'F1') { // 右键新增明细
                e.preventDefault();
                // this.addDetail('sendDataInfo')
                return
            } else if (e.key == 'F2') {
                e.preventDefault();
                this.deleteDetails()
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.sendDataInfo.rgapplydetailInfos.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == this.sendDataInfo.rgapplydetailInfos.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0
                    } else { // 正常递增
                        this.selectedDetailsIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.rgapplydetailInfos[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.rgapplydetailInfos[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.sendDataInfo.rgapplydetailInfos.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex = this.sendDataInfo.rgapplydetailInfos.length - 1
                    } else { // 正常递减
                        this.selectedDetailsIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.rgapplydetailInfos[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.rgapplydetailInfos[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            }

        },
        closeChild() {
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {}
            this.selectedDetailsIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 选择采购员
        selectUserOne(data) {
            data.forEach((item) => {
                if (item.opmId == this.sendDataInfo.rgamPurchaser) {
                    this.sendDataInfo.rgamSapdept = item.depId;
                    this.sendDataInfo.rgamSapdeptName = item.depName;
                }
            });
        },
        initActionBox() {
            this.$confirm("确定取消新增吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$common.delOrderInfo(this.sendDataInfo.psbkmId)
                    this.init();
                    this.dataActionBox.actionType = 0;
                    this.$emit("drawerCancel");
                })
                .catch(() => { });
        },
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.rgapplydetailInfos = [];
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
        },
        // 默认值
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform
            arr.forEach(item => {
                if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
                    this.sendDataInfo[item.entityField] = item.defaultValue
                }
            })
            this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms)
        },
        // 提取采购退货草稿
        async extractData(data) {
            if (data.length >= 1) {
                var sendData = [];
                data.forEach((items) => {
                    sendData.push(items.psbkdId);
                });
                let responseData = await this.$http.extractPurchaseListOrder({
                    ids: sendData,
                });
                if (responseData.status == 200) {
                    this.sendDataInfo = responseData.result;
                    this.sendDataInfo.rgamRapdate = this.$moment().valueOf();
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }
        },
        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            this.filterMainField()
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.getPartDictionariesData();
            this.sendDataInfo.rgamRapdate = this.$moment().valueOf();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.initDefaultValue()
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                for (let key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key])
                }
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.$refs['tree'].init(this.sendDataInfo.rgamId)
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 16.7)
            });
        },
        async sendDataAction(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sub()
                } else {
                    this.$message.error("请完善必填项")
                    return false;
                }
            });
        },
        async sub() {
            if (this.sendDataInfo.rgapplydetailInfos.length <= 0) {
                this.$message({
                    message: "请添加明细",
                    type: "error",
                });
                return false;
            }

            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.RgApplyaddStockRg(sendData);
            } else {
                var responseData = await this.$http.RgApplymodifyStockRg(sendData);
            }
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel");
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        deleteDetails(index) {
            if (this.sendDataInfo.rgapplydetailInfos.length > 0) {
                if (this.selectedDetailsIndex === "") {
                    return this.$message({
                        message: "请先选中明细",
                        type: "warning",
                    });
                } else {
                    this.sendDataInfo.rgapplydetailInfos.splice(
                        this.selectedDetailsIndex,
                        1
                    );
                    this.$nextTick(() => {
                        if (this.sendDataInfo.rgapplydetailInfos.length > 1) {
                            if (this.selectedDetailsIndex != 0) {
                                this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
                            } else {
                                this.selectedDetailsIndex = 0
                            }
                            this.tableNextFocus('bgmName', this.selectedDetailsIndex)
                        } else {
                            this.selectedDetailsIndex = 0
                        }
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.rgapplydetailInfos[this.selectedDetailsIndex]);
                    })
                }
            } else {
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
            }
        },

        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [20, 21],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取退货原因
        async distributionModes() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [40],
            });
            if (responseData.status == 200) {
                this.dictionariesDatas = responseData.result;
                // console.log('退货原因',this.dictionariesDatas);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                    this.mxForm.forEach((item1) => {
                        if (item1.fieldType == "number") {
                            this.$set(this.detaislDataInfo, item1.entityField, 0);
                        } else if (item1.fieldType == "search" && item1.setField) {
                            var arr = item1.setField.split(",");
                            arr.forEach((item2) => {
                                this.$set(this.detaislDataInfo, item2, "");
                            });
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "");
                        }
                    });
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            })
            var arr = [{ entityField: "rgapplydetailInfos" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
        },
    },

    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
            this.isLoaded = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        addEventListener('keyup', this.keyUp)//创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUp)
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.mb {
    margin-bottom: 0;
}

.newInput {
    height: 28px;
    line-height: 28px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}
</style>